import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SUPPORTED_LANGS = ['en', 'pl', 'es', 'fr'];

export function localizedPath(path: string, lang: string): string {
  const clean = lang && SUPPORTED_LANGS.includes(lang) ? lang : 'en';
  if (path === '/') {
    return clean === 'en' ? '/' : `/${clean}`;
  }
  return clean === 'en' ? path : `/${clean}${path}`;
}

export function useLocalizedPath() {
  const { i18n } = useTranslation();
  return (path: string) => localizedPath(path, i18n.language);
}

export function usePageLanguage() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && SUPPORTED_LANGS.includes(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
      document.documentElement.lang = lang;
    }
  }, [lang, i18n]);
}